import { render } from "./PoliciesandCommitment.vue?vue&type=template&id=d4decd18&scoped=true"
import script from "./PoliciesandCommitment.vue?vue&type=script&lang=js"
export * from "./PoliciesandCommitment.vue?vue&type=script&lang=js"

import "./PoliciesandCommitment.vue?vue&type=style&index=0&id=d4decd18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4decd18"]])

export default __exports__